import React from 'react';
import { Label } from './ui/label';
import { FileDropzone } from './FileDropzone';

/**
 * Documents Registration Verification block for the BUSINESS registration form.
 * Renders nationality toggle (for the Director), Company SSM document upload,
 * Director MyKad IC Front/Back OR Passport based on nationality, Installation
 * Address Utility Bill upload, and the RM100 upfront payment disclaimer.
 */
export const BusinessDocsSection = ({ bizNationality, setBizNationality, docs, setDocs }) => {
  return (
    <div className="rounded-xl border border-gray-200 p-5 bg-gray-50/50 space-y-5">
      <div>
        <p className="text-base font-semibold text-gray-900">
          Documents Registration Verification Require <span className="text-red-500">*</span>
        </p>
      </div>

      <div className="flex flex-col gap-2">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name="bizNationality"
            value="malaysian"
            checked={bizNationality === 'malaysian'}
            onChange={() => setBizNationality('malaysian')}
            className="w-4 h-4 accent-[#FF6600]"
            data-testid="biz-nationality-malaysian"
          />
          <span className="text-sm text-gray-800">Malaysian</span>
        </label>
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name="bizNationality"
            value="non-malaysian"
            checked={bizNationality === 'non-malaysian'}
            onChange={() => setBizNationality('non-malaysian')}
            className="w-4 h-4 accent-[#FF6600]"
            data-testid="biz-nationality-non-malaysian"
          />
          <span className="text-sm text-gray-800">Non Malaysian</span>
        </label>
      </div>

      <div className="space-y-2">
        <Label>Company SSM Document</Label>
        <p className="text-xs text-gray-500 -mt-1 leading-relaxed">
          For Trading / Enterprise: Form D, Form A, Form B<br />
          For Sendirian Berhad / Berhad: Form 9, Form 24, Form 49
        </p>
        <FileDropzone id="ssm-doc" value={docs.ssmDoc} onChange={(f) => setDocs(prev => ({ ...prev, ssmDoc: f }))} />
      </div>

      <div className="space-y-4 pt-1">
        {bizNationality === 'malaysian' && (
          <>
            <div className="space-y-2">
              <Label>Upload Director MyKad IC Front for Verification Purpose</Label>
              <p className="text-xs text-gray-500 -mt-1">MyKad must be scanned or photo in colour, not in black and white</p>
              <FileDropzone id="biz-ic-front" value={docs.icFront} onChange={(f) => setDocs(prev => ({ ...prev, icFront: f }))} />
            </div>
            <div className="space-y-2">
              <Label>Upload Director MyKad IC Back for Verification Purpose</Label>
              <p className="text-xs text-gray-500 -mt-1">MyKad must be scanned or photo in colour, not in black and white</p>
              <FileDropzone id="biz-ic-back" value={docs.icBack} onChange={(f) => setDocs(prev => ({ ...prev, icBack: f }))} />
            </div>
          </>
        )}

        {bizNationality === 'non-malaysian' && (
          <div className="space-y-2">
            <Label>Upload Director Passport for Verification Purpose</Label>
            <p className="text-xs text-gray-500 -mt-1">Passport must be scanned or photo in colour, not in black and white</p>
            <FileDropzone id="biz-passport" value={docs.bizPassport} onChange={(f) => setDocs(prev => ({ ...prev, bizPassport: f }))} />
          </div>
        )}
      </div>

      <div className="space-y-2">
        <Label>Installation Address Utility Bill</Label>
        <p className="text-xs text-gray-500 -mt-1">Electricity Bill or Water Bill — any bill that matches your intended installation address</p>
        <FileDropzone id="biz-utility-bill" value={docs.utilityBill} onChange={(f) => setDocs(prev => ({ ...prev, utilityBill: f }))} />
      </div>

      <div className="text-xs text-gray-600 bg-white border border-gray-200 rounded-md p-3 leading-relaxed">
        For Company need to pay <strong>RM100 upfront payment</strong> within ten (10) days effective from date of Service Activation. The amount will be credited into your account. Depending on your billing cycle, the amount will be reflected in your first or second bill. TM reserves the right to terminate the account in the event of non-payment as per required above.
      </div>
    </div>
  );
};
